import React, { Component } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { isProdLike } from '../../configurations/env_config';

if(isProdLike){
    Bugsnag.start({
        apiKey: 'f89d2371ec650616616d3ae68dd406bf',
        plugins: [new BugsnagPluginReact()],
    })
}

export default class FeedPostErrorBoundary extends Component {
    constructor(props){
        super(props);
        this.state = {
            caughtError: false
        }
    }
    static getDerivedStateFromError(error) {
        return { caughtError: true };
      }
    
      componentDidCatch(error, errorInfo) {
        console.log({ error, errorInfo });
        if(isProdLike){
            Bugsnag.notify(errorInfo);
        }
      }
    render() {
        if(this.state.caughtError && isProdLike) return(
            <div className="body-m-semibold article_container" style={{textAlign: 'center'}}>
                Oops!!! Something went wrong.Can't display this item
            </div>
        )
        return this.props.children;
  }
}
